import { useFormContext } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  useFormField,
} from "@/components/ui/form";
import { MentionInput, type UserOptions } from "@/components/ui/mentions";
import type { TextareaProps } from "@/components/ui/textarea";

type Props = TextareaProps & {
  name: string;
  label?: string;
  autoFocus?: boolean;
  description?: string;
  placeholder?: string;
  users: UserOptions;
  forceSuggestionsAboveCursor?: boolean;
};

export const CommentInputField = ({
  label,
  name,
  description,
  placeholder,
  users,
  onKeyDown,
  forceSuggestionsAboveCursor,
}: Props) => {
  const form = useFormContext();
  const { error } = useFormField();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <MentionInput
              {...field}
              onKeyDown={onKeyDown}
              placeholder={placeholder}
              users={users}
              aria-invalid={error ? true : undefined}
              forceSuggestionsAboveCursor={forceSuggestionsAboveCursor}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
